import React, { Component } from 'react'
import * as qs from 'query-string'
import Recherche from './Recherche'
import routes from 'src/routing/routes'
import { decodeBase64, encodeBase64, getValueFromUrlValue } from 'src/utils'
import gql from 'graphql-tag'
import { Query } from 'react-apollo'

const queryGQL = gql`
  query ListProducersWithBounds($category: String!, $bounds: [[Float]]) {
    listProducersWithBounds(category: $category, bounds: $bounds) {
      nbRes
      producers {
        id
        companyName
        presentation
        photoProducerUrl
        categories
        addressCity
        addressPostalCode
        addressCoordinates
      }
    }
  }
`

/*
  Dans ce composant c'est l'url la source de vérité et c'est elle qui alimente la state
 */
class RechercheContainer extends Component {
  constructor(props) {
    super(props)
    const parameters = qs.parse(this.props.location.search)
    const coordinatesTab = parameters.coordinates
      ? parameters.coordinates.split(',')
      : []
    const coordinates =
      coordinatesTab.length > 0
        ? [parseFloat(coordinatesTab[0]), parseFloat(coordinatesTab[1])]
        : null

    this.state = {
      bounds: parameters.bounds,
      category: getValueFromUrlValue(parameters.category),
      page: parameters.page && parameters.page > 0 ? parameters.page : '1',
      coordinates
    }
  }

  componentDidUpdate() {
    const actualUrlParameters = qs.parse(this.props.location.search)
    const category = getValueFromUrlValue(actualUrlParameters.category)

    if (
      actualUrlParameters.page !== this.state.page ||
      actualUrlParameters.bounds !== this.state.bounds ||
      category !== this.state.category
    ) {
      if (actualUrlParameters.coordinates) {
        const coordinatesTab = actualUrlParameters.coordinates
          ? actualUrlParameters.coordinates.split(',')
          : []
        const coordinates =
          coordinatesTab.length > 0
            ? [parseFloat(coordinatesTab[0]), parseFloat(coordinatesTab[1])]
            : []

        this.setState({
          bounds: null,
          page: '1',
          category,
          coordinates
        })
      } else {
        this.setState({
          page:
            actualUrlParameters.page && actualUrlParameters.page > 0
              ? actualUrlParameters.page
              : '1',
          category,
          ...(actualUrlParameters.bounds !== this.state.bounds
            ? { bounds: actualUrlParameters.bounds }
            : {})
        })

        if (typeof window !== 'undefined') window.scrollTo(0, 0)
      }

      if (!actualUrlParameters.page) {
        this.props.history.replace(
          `${routes.recherche}?category=${actualUrlParameters.category}&page=1&bounds=${actualUrlParameters.bounds}`
        )
      }
    }
  }

  updateBounds = bounds => {
    const actualUrlParameters = qs.parse(this.props.location.search)
    this.props.history.replace(
      `${routes.recherche}?category=${
        actualUrlParameters.category
      }&page=1&bounds=${encodeBase64(JSON.stringify(bounds))}`
    )
  }

  render() {
    const bounds =
      this.state.bounds && this.state.bounds !== 'undefined'
        ? JSON.parse(decodeBase64(this.state.bounds))
        : null
    return bounds ? (
      <Query
        query={queryGQL}
        variables={{
          category: this.state.category,
          bounds: bounds.map(bound => [bound.lng, bound.lat])
        }}
      >
        {({ loading, data }) => {
          return (
            <Recherche
              bounds={bounds}
              updateBounds={this.updateBounds}
              loading={loading}
              data={
                data && data.listProducersWithBounds
                  ? data.listProducersWithBounds
                  : null
              }
              page={this.state.page}
            />
          )
        }}
      </Query>
    ) : (
      <Recherche
        coordinates={this.state.coordinates}
        page={this.state.page}
        loading={false}
        updateBounds={this.updateBounds}
      />
    )
  }
}

export default RechercheContainer
